// For running in IE 11
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import cssVars from 'css-vars-ponyfill'

import Vue from 'vue'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import VueMeta from 'vue-meta'
import JsonExcel from 'vue-json-excel/JsonExcel.vue'
import lineClamp from 'vue-line-clamp'
import linkify from 'vue-linkify'
import { sync } from 'vuex-router-sync'
import VueCookie from 'vue-cookie'
import {
  isInCustomerProfileOptions,
  toggleBodyClass,
  timelineItems,
  displayUserName,
  successStatusTranslation,
  exceptionalCustomers,
  isKeyCloakActive,
} from '@/helper'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import installCustomRules from '@/validation/rules'
import { VueMasonryPlugin } from 'vue-masonry'

import { i18n } from '@/translations/i18n'
import vuetify from 'customerPath/vuetify'
import VueGtm from '@gtm-support/vue2-gtm'
import VueSocialSharing from 'vue-social-sharing'
import router from '@/router'
import store from 'customerPath/store'

// import VueGtag after router
import VueGtag from 'vue-gtag'

// Sentry stuff
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import { Integrations } from '@sentry/tracing'

import { customerConfig, iconMapping } from 'customerPath/config'

import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import App from 'customerPath/app/App'

import Cookie from 'js-cookie'

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

installCustomRules(extend)

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('downloadExcel', JsonExcel)

Vue.directive('linkified', linkify)

sync(store, router)

Vue.prototype.iconMapping = iconMapping
Vue.prototype.toggleBodyClass = toggleBodyClass
Vue.prototype.timelineItems = timelineItems
Vue.prototype.customerConfig = customerConfig
Vue.prototype.isInCustomerProfileOptions = isInCustomerProfileOptions
Vue.prototype.displayUserName = displayUserName
Vue.prototype.successStatusTranslation = successStatusTranslation
Vue.prototype.exceptionalCustomers = exceptionalCustomers
Vue.prototype.isKeyCloakActive = isKeyCloakActive

Vue.config.productionTip = false

Vue.use(VueLodash, { lodash: lodash })
Vue.use(lineClamp, { importCss: true })
Vue.use(VueCookie)
Vue.use(VueMeta)
Vue.use(VueMasonryPlugin)
Vue.use(VueSocialSharing)


const buildTracking = auth => {
  const cookie_settings = auth && auth.cookie_config
  const cdisc = Cookie.get('cdisc') === 'true'
  let activeCategories
  try {
    activeCategories = JSON.parse(Cookie.get('cookie_config'))
  } catch (e) {
    activeCategories = [ 1 ]
  }
  const track_all = Cookie.get('track_all') === 'true'

  const getActiveForProviderType = type => {
    const providerCategories = cookie_settings ? cookie_settings.provider_type_to_cookie_type_mapping[type] || [] : []
    return Boolean(activeCategories.length && providerCategories.length &&
                   providerCategories.some(r => activeCategories.indexOf(r) >= 0))
  }

  const activeServices = []
  const storedItems = cookie_settings && cookie_settings.items || []
  storedItems.forEach(item => {
    if (track_all || activeCategories.indexOf(item.cookie_type) >= 0) {
      const storedProviders = item.provider || []
      storedProviders.forEach(provider => {
        activeServices.push(provider.service_id || null)
      })
    }
  })

  window.activeServices = [...new Set(activeServices)]
  window.activeCategories = activeCategories

  const isGaActive = cdisc && (track_all || getActiveForProviderType('2'))
  const isGtmActive = cdisc && (track_all || getActiveForProviderType('3'))

  const apiSettings = store.state && store.state.auth && store.state.auth.settings
  const noLayerCheck = Boolean(
    apiSettings && apiSettings.base_options && !apiSettings.base_options.show_cookie_layer,
  )

  if (process.env.VUE_APP_ANALYTICS_ID) {

    /* Use google tracking (universal analytics or tag manger) if VUE_APP_ANALYTICS_ID is given. */

    // If ID matches universal Analytics (starting with 'UA-') use VueGtag, otherwise use vueGtm
    if (lodash.startsWith(process.env.VUE_APP_ANALYTICS_ID.toLowerCase(), 'ua-')) {
      if (isGaActive || noLayerCheck) {
        Vue.use(VueGtag, {
          config: {
            id: process.env.VUE_APP_ANALYTICS_ID,
            params: {
              anonymize_ip: true,
            },
          },
        }, router) // track all routes automatically
      }
    } else if (isGtmActive || noLayerCheck) {
      Vue.use(VueGtm, {
        id: process.env.VUE_APP_ANALYTICS_ID,
        vueRouter: router, // Pass the router instance to automatically sync with router
        trackOnNextTick: true, // Whether or not call trackView in Vue.nextTick
      })
    }
  }
}

if (process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      new VueIntegration({
        Vue,
        tracing: true,
      }),
      new Integrations.BrowserTracing(),
    ],

    // We recommend adjusting this value in production, or using tracesSampler for finer control
    tracesSampleRate: 1.0,
    // Track all components
    tracingOptions: {
      trackComponents: true,
    },
  })
}

if (process.env.VUE_APP_KEYCLOAK_INSTANCE) {
  window.VUE_APP_KEYCLOAK_INSTANCE = process.env.VUE_APP_KEYCLOAK_INSTANCE
}

store.dispatch('auth/getSettings').then(data => {
  buildTracking(data)
  store.dispatch('auth/initAuth').then(_ => {
    store.dispatch('translations/getAvailableLanguages').then(_ => {
      new Vue({
        i18n,
        router,
        store,
        vuetify,
        render: h => h(App),
      }).$mount('#app')
    })
  })
})

// transpile css vars on the fly - for IE 11 and other legacy browsers
cssVars({
  onlyLegacy: true,
  shadowDOM: true,
  watch: true,
})
